import dayjs from "dayjs";
import { PlanPackageValidationDetails } from "features/types";
import i18n from "plugins/localization";
import { Dimensions } from "react-native";
import * as yup from "yup";

export const MAX_ACCOUNT_PLAN_PACKAGE_COUNT = 8;

export const isSmallScreen = Dimensions.get("window").width <= 768;

export const isBigScreen = Dimensions.get("window").width > 768;

export const FANRALLY_THEME = "rgb(38, 93, 132)";

export const DARK_THEME_PRIMARY = "rgb(34, 44, 68)";

export const ACCOUNT_STACK_BACKGROUND_COLOR = "rgb(248, 248, 248)";

export const AUTH_SCREEN_BUTTON_BACKGROUND = "#272727";

export const BRANDING_URL = "https://branding.fanrally.com";

export const DASHBOARD_CARD_WIDTH = isSmallScreen ? 170 : 250;

export const DASHBOARD_RESERVATION_CARD_HEIGHT = 210;

export const DASHBOARD_VOUCHER_CARD_HEIGHT = 225;

export const DARK_THEME_BACKGROUND = "#101426";

export const LIGHT_BLUE = "#2196f3";

export const FANRALLY_LOGO_MASTER =
  "https://branding.fanrally.com/logos/fanrally_logo_master.png";

interface SchemaOptions {
  emailValidation?: PlanPackageValidationDetails;
}

export const validationSchemas = (options?: SchemaOptions) => {
  const { emailValidation } = options || {};
  const basicValidation = {
    firstName: yup
      .string()
      .matches(/^[a-z ,.'-]+$/i, i18n.t("errors.form.alphabetsOnly"))
      .label("First Name")
      .required(i18n.t("errors.form.required")),
    lastName: yup
      .string()
      .matches(/^[a-z ,.'-]+$/i, i18n.t("errors.form.alphabetsOnly"))
      .label("Last Name")
      .required(i18n.t("errors.form.required")),
    phone: yup
      .string()
      .transform((value) => value && value.replace(/[^\d]/g, ""))
      .matches(/^\d{10}$/, i18n.t("errors.form.phone"))
      .typeError(i18n.t("errors.form.phone"))
      .label("Phone number")
      .required(i18n.t("errors.form.required")),
    email: (emailValidation
      ? yup
          .string()
          .matches(
            new RegExp(emailValidation.emailRegexPattern),
            emailValidation.errorMessage
          )
      : yup.string()
    )
      .email(i18n.t("errors.form.email"))
      .label("Email")
      .required(i18n.t("errors.form.required"))
      .typeError(i18n.t("errors.form.email")),
    addressLine1: yup.string().max(100).nullable(),
    addressLine2: yup.string().max(100).nullable(),
    city: yup.string().max(50).nullable(),
    postalCode: yup.string().max(50).nullable(),
  };
  const passwordValidation = {
    password: yup
      .string()
      .min(6, i18n.t("errors.form.passwordMinimumLength"))
      .label("Password")
      .required(),

    confirmPassword: yup
      .string()
      .oneOf(
        [yup.ref("password"), null],
        i18n.t("errors.form.passwordsMustMatch")
      )
      .required(i18n.t("errors.form.passwordsMustMatch")),
  };
  const editingChildValidation = {
    firstName: yup
      .string()
      .matches(/^[a-z ,.'-]+$/i, i18n.t("errors.form.alphabetsOnly"))
      .required(i18n.t("errors.form.required")),
    lastName: yup
      .string()
      .matches(/^[a-z ,.'-]+$/i, i18n.t("errors.form.alphabetsOnly"))
      .required(i18n.t("errors.form.required")),
  };
  // tenant user fields
  const birthdateValidation = yup
    .string()
    .test("Birthdate", i18n.t("errors.form.birthdate"), (value) => {
      if (!value) return true;
      const enteredDate = dayjs(value);
      // returns true if date is before today and less than 100 years old
      return (
        /\d{2}\/\d{2}\/\d{4}/.test(value) &&
        enteredDate.isBefore(dayjs()) &&
        dayjs().diff(enteredDate, "years") < 100
      );
    });

  return {
    basicValidation,
    passwordValidation,
    editingChildValidation,
    birthdateValidation,
  };
};
